import { AbstractControl, ValidationErrors } from '@angular/forms';

/** 9 caracteres: 5 dígitos, hífen na 6ª posição (índice 5) e 3 dígitos. Ex.: 00000-000 */
const CEP_REGEX = /^\d{5}-\d{3}$/;

/**
 * Valida o formato do CEP (00000-000).
 * Campo vazio é considerado válido — quem cobra o preenchimento é o Validators.required.
 */
export function cepValidator(control: AbstractControl<string>): ValidationErrors | null {
  const cep = (control.value ?? '').trim();

  if (!cep) {
    return null;
  }

  return CEP_REGEX.test(cep) ? null : { cep: true };
}
